import { isValidElement } from 'react';
import { isReactComponent } from './isReactComponent';
/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isCustomView(obj) {
  return obj && ( /*#__PURE__*/isValidElement(obj) || isReactComponent(obj));
}